import './styles/base.css';
import { useRoute } from './lib/router';
import { Admin } from './routes/Admin';
import { Play } from './routes/Play';
import { Run } from './routes/Run';

/**
 * Routing.
 *
 *   /                landing
 *   /admin           instructor console — sign in, import, sessions
 *   /run/<sessionId> instructor's live controls for one session
 *   /s/<CODE>        participant view
 */
export default function App() {
  const { path, navigate } = useRoute();

  if (path === '/admin') return <Admin />;

  const run = /^\/run\/([\w-]+)$/.exec(path);
  if (run) return <Run sessionId={run[1]!} />;

  const play = /^\/s\/([A-Za-z0-9]+)$/.exec(path);
  if (play) return <Play code={play[1]!.toUpperCase()} />;

  return <Landing onAdmin={() => navigate('/admin')} />;
}

function Landing({ onAdmin }: { onAdmin: () => void }) {
  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        padding: 'var(--s-6)',
      }}
    >
      <div style={{ maxWidth: '46ch', textAlign: 'center' }}>
        <p className="eyebrow" style={{ marginBottom: 'var(--s-4)' }}>
          Guided exam sessions
        </p>
        <h1>Examatron™</h1>
        <p style={{ color: 'var(--mist)', marginTop: 'var(--s-5)', fontSize: 17 }}>
          One question at a time, for the whole room at once.
        </p>
        <p style={{ color: 'var(--slate)', marginTop: 'var(--s-5)', fontSize: 14 }}>
          Have a session code? Your instructor will share a link.
        </p>
        <p style={{ marginTop: 'var(--s-6)' }}>
          <a
            href="/admin"
            onClick={(e) => {
              e.preventDefault();
              onAdmin();
            }}
            style={{ color: 'var(--accent)', fontSize: 14 }}
          >
            Instructor sign-in
          </a>
        </p>
      </div>
    </main>
  );
}
